import { unwrapPaginationMeta, } from './api/unwrapModel';
export const buildPaginationFromResponse = (response, onNext, onPrev) => {
    if (!response)
        return undefined;
    const paginationMeta = unwrapPaginationMeta(response);
    if (!paginationMeta)
        return undefined;
    return {
        ...paginationMeta,
        onNext,
        onPrev,
    };
};
